import React, { useState } from 'react';
import __ from 'localisation';
import { useDocuments } from 'queries/documents';
import SimpleTable from 'modules/Tables/SimpleTable';
import LoadingBar from '@hubins/components/LoadingIndicators';
import AuthDownloadLink from '@hubins/components/AuthDownloadLink';
import MultipleDropdown from '@hubins/components/MultipleDropdown';
import Button from '@hubins/components/Button';
import EditDocumentModal from './EditDocumentModal';
import DeleteDocumentButton from './DeleteDocumentButton';

export type Document = {
  downloadLink: string;
  editLink: string;
  deleteLink: string;
  name: string;
  created_at: string;
  created_by: string;
};

const typeOptions = [
  {
    id: 'fa_profile',
    title: 'FA Profile',
  },
  {
    id: 'fa_portfolio',
    title: 'FA Portfolio',
  },
  {
    id: 'portfolio',
    title: 'Portfolio',
  },
  {
    id: 'profile',
    title: 'Profile',
  },
  {
    id: 'sof',
    title: 'Source of funds',
  },
  {
    id: 'approval',
    title: 'Approval',
  }
];

const loadingObj = {
  downloadLink: '',
  name: <LoadingBar />,
  created_at: <LoadingBar />,
  created_by: <LoadingBar />,
  source: '',
};

const loadingState = [
  loadingObj,
  loadingObj,
  loadingObj,
  loadingObj,
  loadingObj,
  loadingObj,
  loadingObj,
  loadingObj,
  loadingObj,
  loadingObj,
  loadingObj,
];

const BackofficeDocuments = ({ portfolioUuid, profileUuid }) => {

  const [types, setTypes] = useState([]);
  const [edit, setEdit] = useState<Document | null>(null);

  const { data: documents, isLoading, isFetched, refetch } = useDocuments(types, profileUuid, portfolioUuid);

  const headers = [
    {
      Header: '',
      width: 23,
      accessor: 'downloadLink',
      Cell: ({ value, row }) => (
        <>
          {value ? (
            <AuthDownloadLink url={value} filename={row.original.name} onlyIcon />
          ) : (
            <LoadingBar />
          )}
        </>
      ),
    },
    {
      Header: '',
      accessor: 'editLink',
      width: 23,
      Cell: ({ value, row }) => (
        value ? (
          <Button icon="pencil write 2" onClick={() => setEdit(row.original)} onlyIcon />
        ) : <></>
      )
    },
    {
      Header: '',
      width: 27,
      accessor: 'deleteLink',
      Cell: ({ value, row }) => (
        value ? <DeleteDocumentButton document={row.original} refetch={refetch} /> : <></>
      )
    },
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Created at',
      accessor: 'created_at',
    },
    {
      Header: 'Created by',
      accessor: 'created_by',
    },
    {
      Header: 'Source',
      accessor: 'source',
      Cell: ({ value }) => (
        value ? __('doc_source_' + value) : <LoadingBar />
      ),
    }
  ];

  return (
    <div className="s-top-xl">
      {edit && (
        <EditDocumentModal document={edit} setDocument={setEdit} refetch={refetch} />
      )}
      <MultipleDropdown
        className="input-max-width"
        label="Source"
        placeholder="Select source"
        options={typeOptions}
        values={types}
        callback={setTypes}
      />
      <div className="s-top-l" />
      <SimpleTable
        headers={headers}
        data={(isLoading || !isFetched) ? loadingState : documents}
      />
    </div>
  );

};

export default BackofficeDocuments;
